module.exports = __webpack_public_path__ + "static/media/Decisions_Step7_endcard.b4bcdf2f.webp";